module.exports = __webpack_public_path__ + "static/media/p6_2.9514a8ee.png";